function fvisitToLink() {

  var lStorage = localStorage.getItem('riversol_first_visit');
  var parentCookie = parent.getCookie ? parent.getCookie('riversol_first_visit') : null;
  var fvisitlink = lStorage || parentCookie;

  if(!fvisitlink) {
    var fvisitlink = window.location.href;
    localStorage.setItem("riversol_first_visit", fvisitlink);
    document.cookie = "riversol_first_visit=" + fvisitlink + "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
  }	

  document.querySelectorAll('a.lp-pom-button, a.mi-body-box').forEach(function(item, idx){
    var href = item.href;
    item.href = href + '&attributes[First Visit]=' + fvisitlink.replace(/&/g,"%26");
  })

  if(!sessionStorage.getItem('riversol_landing_url')) {
    var url = encodeURIComponent(window.location.href);
    sessionStorage.setItem("riversol_landing_url", url);
  }

  if(!sessionStorage.getItem('riversol_referring_url')) {
    var url = encodeURIComponent(document.referrer);
    sessionStorage.setItem("riversol_referring_url", url);
  }
  
}

fvisitToLink();